import { useAuth } from '../context/AuthContext';
import { useCallback, useMemo } from 'react';

export const useCapabilities = () => {
    const { agentInfo } = useAuth();

    const hasCapability = useCallback((capability) => {
        if (!agentInfo || !agentInfo.permissions || !agentInfo.permissions.capabilities) {
            console.log("DEBUG [useCapabilities] No agentInfo or permissions found", agentInfo);
            return false;
        }
        const isAllowed = agentInfo.permissions.capabilities.includes(capability);
        console.log(`DEBUG [useCapabilities] User caps:`, agentInfo.permissions.capabilities, `Checking: ${capability}, Result: ${isAllowed}`);
        return isAllowed;
    }, [agentInfo]);

    return useMemo(() => ({
        hasCapability,
        capabilities: agentInfo?.permissions?.capabilities || []
    }), [hasCapability, agentInfo?.permissions?.capabilities]);
};
